import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "d-flex flex-column flex-root app-root",
  id: "kt_app_root"
}
const _hoisted_2 = {
  class: "app-page flex-column flex-column-fluid",
  id: "kt_app_page"
}
const _hoisted_3 = {
  class: "app-main flex-column flex-row-fluid",
  id: "kt_app_main"
}
const _hoisted_4 = { class: "d-flex flex-column flex-column-fluid" }
const _hoisted_5 = {
  id: "kt_app_content",
  class: "app-content flex-column-fluid"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_KTHeader = _resolveComponent("KTHeader")!
  const _component_KTContent = _resolveComponent("KTContent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.withHeader === true)
        ? (_openBlock(), _createBlock(_component_KTHeader, { key: 0 }))
        : _createCommentVNode("", true),
      _createElementVNode("div", {
        class: _normalizeClass({'flex-column flex-row-fluid': true, 'app-wrapper': _ctx.withHeader === true}),
        id: "kt_app_wrapper"
      }, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_KTContent)
            ])
          ])
        ])
      ], 2)
    ])
  ]))
}